// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Reservation package show (Stitch: Sara Nasser) ——— */
.rp-show {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.rp-show__inner {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
}

.rp-show__stack {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* Hero */
.rp-show__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #F1F5F9;
}

.rp-show__hero-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.rp-show__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rp-show__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .rp-show__back .lucide {
  transform: scaleX(-1);
}

.rp-show__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}

.rp-show__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.rp-show__meta {
  margin: 2px 0 0;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  line-height: 1.4;
}

.rp-show__hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rp-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rp-show__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.rp-show__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.rp-show__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
}

.rp-show__btn--ghost .lucide {
  color: #94A3B8;
}

.rp-show__btn--danger {
  border: 1px solid #FECDD3;
  background: #ffffff;
  color: #E11D48;
}

.rp-show__btn--danger:hover:not(:disabled) {
  background: #FFF1F2;
}

.rp-show__btn--danger .lucide {
  color: #E11D48;
}

.rp-show__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  padding-inline: 16px;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.rp-show__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.rp-show__btn--footer {
  height: auto;
  padding: 8px 16px;
}

.rp-show__btn--book {
  height: auto;
  padding: 10px 20px;
  gap: 8px;
}

.rp-show__btn--book .lucide {
  color: #ffffff;
}

/* Status pills */
.rp-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: auto;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1.4;
}

.rp-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.rp-show__status.is-available {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.rp-show__status.is-available .rp-show__status-dot {
  background: #10B981;
}

.rp-show__status.is-partial {
  background: #F0F9FF;
  color: #0284C7;
  border-color: #BAE6FD;
}

.rp-show__status.is-partial .rp-show__status-dot {
  background: #0EA5E9;
}

.rp-show__status.is-settled {
  background: #F0FDFA;
  color: #0D9488;
  border-color: #99F6E4;
}

.rp-show__status.is-settled .rp-show__status-dot {
  background: #0D9488;
}

.rp-show__status.is-cancelled {
  background: #FEF2F2;
  color: #B91C1C;
  border-color: #FECACA;
}

.rp-show__status.is-cancelled .rp-show__status-dot {
  background: #EF4444;
}

.rp-show__status.is-waiting {
  background: #FFFBEB;
  color: #D97706;
  border-color: #FDE68A;
}

.rp-show__status.is-waiting .rp-show__status-dot {
  background: #F59E0B;
}

.rp-show__status.is-scheduled {
  background: #F0F9FF;
  color: #0284C7;
  border-color: #BAE6FD;
}

.rp-show__status.is-scheduled .rp-show__status-dot {
  background: #0284C7;
}

.rp-show__status.is-muted {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.rp-show__status.is-muted .rp-show__status-dot {
  background: #94A3B8;
}

/* Summary card — Stitch slate-50/60 panel */
.rp-show__summary {
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.6);
}

.rp-show__summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 16px;
  margin: 0;
}

@media (min-width: 768px) {
  .rp-show__summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1100px) {
  .rp-show__summary-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.rp-show__field {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.rp-show__field--wide {
  grid-column: span 2;
}

.rp-show__field dt {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8;
}

.rp-show__field dd {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.4;
  word-break: break-word;
}

.rp-show__patient-value {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.rp-show__patient-link {
  color: #0F172A;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
}

.rp-show__patient-link:hover {
  color: #0EA5E9;
}

.rp-show__code-badge {
  display: inline-flex;
  align-items: center;
  height: auto;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid rgba(191, 219, 254, 0.6);
  background: #EFF6FF;
  color: #0284C7;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.rp-show__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  font-size: 12px;
  color: #1E293B;
}

.rp-show__price {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 12px;
  color: #0F172A;
}

.rp-show__remainder {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #0284C7;
  font-weight: 600;
  font-size: 12px;
}

.rp-show__remainder .lucide {
  flex-shrink: 0;
  color: #0284C7;
}

.rp-show__muted {
  color: #94A3B8;
  font-weight: 400;
}

.rp-show__package-link {
  color: #1E293B;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
}

.rp-show__package-link:hover {
  color: #0EA5E9;
}

.rp-show__referring {
  font-size: 12px;
  font-weight: 500;
  color: #1E293B;
}

/* Usages */
.rp-show__usages-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.rp-show__usages-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.3;
}

.rp-show__usages-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.rp-show__quota-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: auto;
  padding: 4px 10px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.rp-show__quota-chip .lucide {
  flex-shrink: 0;
}

.rp-show__table-card {
  box-sizing: border-box;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}

.rp-show__table-scroll {
  width: 100%;
  overflow-x: auto;
}

.rp-show__table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  font-size: 12px;
  text-align: start;
}

.rp-show__table thead th {
  padding: 12px 16px;
  text-align: start;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  white-space: nowrap;
}

.rp-show__table thead th.is-action {
  text-align: end;
}

.rp-show__table tbody td {
  padding: 12px 16px;
  vertical-align: middle;
  color: #334155;
  border-bottom: 1px solid #F1F5F9;
}

.rp-show__table tbody tr:last-child td {
  border-bottom: 0;
}

.rp-show__table tbody tr:hover td {
  background: rgba(248, 250, 252, 0.8);
}

.rp-show__table td.is-action {
  text-align: end;
}

.rp-show__date {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #1E293B;
  white-space: nowrap;
}

.rp-show__doctor {
  font-weight: 600;
  color: #0F172A;
}

.rp-show__clinic {
  color: #475569;
}

/* Stitch: slate mono chip (not sky pill) */
.rp-show__appt-id {
  display: inline-flex;
  align-items: center;
  height: auto;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  color: #334155;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  font-size: 12px;
}

.rp-show__row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.rp-show__row-link:hover {
  text-decoration: underline;
  color: #0284C7;
}

[dir='rtl'] .rp-show__row-link .lucide {
  transform: scaleX(-1);
}

.rp-show__empty {
  padding: 32px 16px;
  text-align: center;
  color: #94A3B8;
  font-size: 13px;
}

/* Footer */
.rp-show__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 16px;
  border-top: 1px solid #F1F5F9;
  margin-top: auto;
}

@media (max-width: 640px) {
  .rp-show {
    padding: 16px;
  }

  .rp-show__title {
    font-size: 18px;
  }

  .rp-show__field--wide {
    grid-column: span 1;
  }

  .rp-show__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .rp-show__footer .rp-show__btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowReservationPackage/style.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ——— Reservation package show (Stitch: Sara Nasser) ——— */\n.rp-show {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 24px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n\n.rp-show__inner {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.rp-show__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* Hero */\n.rp-show__hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.rp-show__hero-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.rp-show__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rp-show__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .rp-show__back .lucide {\n  transform: scaleX(-1);\n}\n\n.rp-show__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  min-width: 0;\n}\n\n.rp-show__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.rp-show__meta {\n  margin: 2px 0 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.rp-show__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rp-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rp-show__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rp-show__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.rp-show__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.rp-show__btn--ghost .lucide {\n  color: #94A3B8;\n}\n\n.rp-show__btn--danger {\n  border: 1px solid #FECDD3;\n  background: #ffffff;\n  color: #E11D48;\n}\n\n.rp-show__btn--danger:hover:not(:disabled) {\n  background: #FFF1F2;\n}\n\n.rp-show__btn--danger .lucide {\n  color: #E11D48;\n}\n\n.rp-show__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  padding-inline: 16px;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.rp-show__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.rp-show__btn--footer {\n  height: auto;\n  padding: 8px 16px;\n}\n\n.rp-show__btn--book {\n  height: auto;\n  padding: 10px 20px;\n  gap: 8px;\n}\n\n.rp-show__btn--book .lucide {\n  color: #ffffff;\n}\n\n/* Status pills */\n.rp-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: auto;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.rp-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.rp-show__status.is-available {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.rp-show__status.is-available .rp-show__status-dot {\n  background: #10B981;\n}\n\n.rp-show__status.is-partial {\n  background: #F0F9FF;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.rp-show__status.is-partial .rp-show__status-dot {\n  background: #0EA5E9;\n}\n\n.rp-show__status.is-settled {\n  background: #F0FDFA;\n  color: #0D9488;\n  border-color: #99F6E4;\n}\n\n.rp-show__status.is-settled .rp-show__status-dot {\n  background: #0D9488;\n}\n\n.rp-show__status.is-cancelled {\n  background: #FEF2F2;\n  color: #B91C1C;\n  border-color: #FECACA;\n}\n\n.rp-show__status.is-cancelled .rp-show__status-dot {\n  background: #EF4444;\n}\n\n.rp-show__status.is-waiting {\n  background: #FFFBEB;\n  color: #D97706;\n  border-color: #FDE68A;\n}\n\n.rp-show__status.is-waiting .rp-show__status-dot {\n  background: #F59E0B;\n}\n\n.rp-show__status.is-scheduled {\n  background: #F0F9FF;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.rp-show__status.is-scheduled .rp-show__status-dot {\n  background: #0284C7;\n}\n\n.rp-show__status.is-muted {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.rp-show__status.is-muted .rp-show__status-dot {\n  background: #94A3B8;\n}\n\n/* Summary card — Stitch slate-50/60 panel */\n.rp-show__summary {\n  box-sizing: border-box;\n  padding: 20px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.6);\n}\n\n.rp-show__summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 24px;\n  row-gap: 16px;\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n  .rp-show__summary-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1100px) {\n  .rp-show__summary-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n.rp-show__field {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.rp-show__field--wide {\n  grid-column: span 2;\n}\n\n.rp-show__field dt {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.rp-show__field dd {\n  margin: 4px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.rp-show__patient-value {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.rp-show__patient-link {\n  color: #0F172A;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.rp-show__patient-link:hover {\n  color: #0EA5E9;\n}\n\n.rp-show__code-badge {\n  display: inline-flex;\n  align-items: center;\n  height: auto;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid rgba(191, 219, 254, 0.6);\n  background: #EFF6FF;\n  color: #0284C7;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.rp-show__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  font-size: 12px;\n  color: #1E293B;\n}\n\n.rp-show__price {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 12px;\n  color: #0F172A;\n}\n\n.rp-show__remainder {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #0284C7;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.rp-show__remainder .lucide {\n  flex-shrink: 0;\n  color: #0284C7;\n}\n\n.rp-show__muted {\n  color: #94A3B8;\n  font-weight: 400;\n}\n\n.rp-show__package-link {\n  color: #1E293B;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.rp-show__package-link:hover {\n  color: #0EA5E9;\n}\n\n.rp-show__referring {\n  font-size: 12px;\n  font-weight: 500;\n  color: #1E293B;\n}\n\n/* Usages */\n.rp-show__usages-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.rp-show__usages-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.rp-show__usages-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.rp-show__quota-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: auto;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.rp-show__quota-chip .lucide {\n  flex-shrink: 0;\n}\n\n.rp-show__table-card {\n  box-sizing: border-box;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.rp-show__table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.rp-show__table {\n  width: 100%;\n  min-width: 760px;\n  border-collapse: collapse;\n  font-size: 12px;\n  text-align: start;\n}\n\n.rp-show__table thead th {\n  padding: 12px 16px;\n  text-align: start;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  white-space: nowrap;\n}\n\n.rp-show__table thead th.is-action {\n  text-align: end;\n}\n\n.rp-show__table tbody td {\n  padding: 12px 16px;\n  vertical-align: middle;\n  color: #334155;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.rp-show__table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.rp-show__table tbody tr:hover td {\n  background: rgba(248, 250, 252, 0.8);\n}\n\n.rp-show__table td.is-action {\n  text-align: end;\n}\n\n.rp-show__date {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #1E293B;\n  white-space: nowrap;\n}\n\n.rp-show__doctor {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.rp-show__clinic {\n  color: #475569;\n}\n\n/* Stitch: slate mono chip (not sky pill) */\n.rp-show__appt-id {\n  display: inline-flex;\n  align-items: center;\n  height: auto;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  color: #334155;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.rp-show__row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.rp-show__row-link:hover {\n  text-decoration: underline;\n  color: #0284C7;\n}\n\n[dir='rtl'] .rp-show__row-link .lucide {\n  transform: scaleX(-1);\n}\n\n.rp-show__empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 13px;\n}\n\n/* Footer */\n.rp-show__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding-top: 16px;\n  border-top: 1px solid #F1F5F9;\n  margin-top: auto;\n}\n\n@media (max-width: 640px) {\n  .rp-show {\n    padding: 16px;\n  }\n\n  .rp-show__title {\n    font-size: 18px;\n  }\n\n  .rp-show__field--wide {\n    grid-column: span 1;\n  }\n\n  .rp-show__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rp-show__footer .rp-show__btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
